import React, { Component } from 'react'
import styles from './Navbar.css';
import { Link , Switch, Route} from 'react-router-dom';
import About from '../../components/About/About';
import Menu from '../../components/Menu/Menu';
import Contact from '../../components/Contact/Contact';


class navBar extends Component {
    state = {
        ordNum: 0
    }
    
    render() {
        return (
            <div >
                <nav className={styles.NavBar}>
                    <ul>
                        <li>
                            <Link to='/'>About</Link>
                        </li>
                        <li>
                            <Link to='/menu'>Menu</Link>
                        </li>
                        <li>
                            <Link to='/contact'>Contact</Link>
                        </li>
                    </ul>
                </nav>
                <Switch>
             <Route exact path='/' component={About}/>
             <Route path='/menu' component={Menu}/>  
             <Route path='/contact' component={Contact}/>  
             {/* <Route path='/order' component={Order}/> */}
             <Route render={() => <h1>404 Page Not Found</h1>}/>  
           </Switch>
            </div>
            
        )
    }
}




export default navBar;



// WEBPACK FOOTER //
// ./src/containers/NavBar/NavBar.js